import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RelatedRoutingModule} from './related-routing.module';
import {RelatedComponent} from './components/related/related.component';
import {RelatedCategoryComponent} from './components/related-category/related-category.component';
import {RelatedCategoryDetailsComponent} from './components/related-category-details/related-category-details.component';
import {SharedModule} from '../../app-common/shared.module';
import {RelatedService} from './services/related.service';
import {UiIconComponent} from '../../components/ui/ui-icon/ui-icon.component';

@NgModule({
  declarations: [RelatedComponent, RelatedCategoryComponent, RelatedCategoryDetailsComponent],
  imports: [
    CommonModule,
    RelatedRoutingModule,
    // SearchWidgetV2Module,
    SharedModule,
    UiIconComponent,
  ],
  providers: [RelatedService],
})
export class RelatedModule {}
